import request from '@/utils/request'

// 获取账号安全详情
export function account_security_detail() {
  return request({
    url: process.env.VUE_APP_MEMBERWEB + '/user/pwd_login_code_verify/detail',
    method: 'post'
  })
}

// 修改账号安全配置
export function account_security_modify(data) {
  return request({
    url: process.env.VUE_APP_MEMBERWEB + '/user/pwd_login_code_verify/modify',
    method: 'post',
    data
  })
}

